<!-- USER - PROFILE AND NAVIGATION -->
<div id="userNav" class="user-info">
  @if ((layoutService.screenRange$ | async).ltMd) {
    <ag-logo-title
      [responsive]="false"
      [settings]="{
        layoutSettings: layoutService.layoutSettings$ | async,
        libraryName: userData.libraryName
      }"
    ></ag-logo-title>
  }
  <!-- LOGGED IN -->
  @if ((layoutService.screenRange$ | async).ltMd && !a11y) {
    @if (!userData?.isGuest) {
      <div class="user-signed pull-left block">
        <div class="width-100">
          <span class="user-name"> Welcome, {{ userData?.firstName }}</span>
        </div>
      </div>
    }
  }

  <!-- MAIN NAVIGATION --
  Home, Dashboard, Blank ILL Request, Page Links, Advanced Search,
  Your Items, Your Account, Your List, Guest Ill Tracking.
  A11y - Counts the <a> tag with an ID && tabindex, pushes it in an array, then uses tab to cycle to the differences.
  -->
  <div class="user-navigation">
    <a tabindex="0" class="block" (agInteract)="goToHome()">
      <i class="fa fa-home" aria-hidden="true"></i>
      <h5 class="inline">Home</h5>
    </a>

    <!-- STAFF DASHBOARD -->
    @if ((layoutService.screenRange$ | async).ltMd && !a11y) {
      @if (!userData?.isGuest && userData?.isStaff) {
        <a tabindex="0" class="block" (agInteract)="goToDashboard()"
          ><i class="fa fa-window-maximize" aria-hidden="true"></i>
          <h5 class="inline">Staff Dashboard</h5>
        </a>
      }
      <!-- QUICK MENU -->
      @if (!userData?.isGuest && userData?.isStaff) {
        <a tabindex="0" class="block" (agInteract)="openQuickMenu()"
          ><i class="fa fa-heart" aria-hidden="true"></i>
          <h5 class="inline">Quick Links</h5>
        </a>
      }
      @if (!userData?.isGuest) {
        <a tabindex="0" class="block" (agInteract)="openNotifications()">
          <i class="fa fa-bell-o" aria-hidden="true"></i>
          <h5 class="inline">Notifications</h5>
        </a>
      }
      <!-- GUEST ILL TRACKING -->
      @if (showGuestTracking) {
        <a tabindex="0" class="block" (agInteract)="openGuestTracking()"
          ><i class="fa fa-list-ol" aria-hidden="true"></i>
          <h5 class="inline">Guest ILL Tracking</h5>
        </a>
      }
      <!-- BLANK ILL REQUEST -- Find variable-->
      @if (userData?.illOptions.showBlankILL) {
        <a tabindex="0" class="block" (agInteract)="goToIllRequestBlank()"
          ><i class="fa fa-file-text-o" aria-hidden="true"></i>
          <h5 class="inline">Blank ILL Request</h5>
        </a>
      }
      <!-- ADVANCED SEARCH - Find Variable -->
      <a tabindex="0" class="block" (agInteract)="goToAdvancedSearch()">
        <i class="fa fa-search-plus" aria-hidden="true"></i>
        <h5 class="inline">Advanced Search</h5>
      </a>
      <!-- Library Card -->
      @if (showDigitalLibraryCard) {
        <a tabindex="0" class="block" (agInteract)="openCard()">
          <i class="fa fa-id-card" aria-hidden="true"></i>
          <h5 class="inline">Library Card</h5>
        </a>
      }
      <!-- PAGE LINKS -->
      @for (page of pages; track page; let i = $index) {
        @if (
          (userData?.isGuest && page?.showGuest) ||
          (userData?.isPatron && page?.showPatron) ||
          (userData?.isStaff && page?.showStaff)
        ) {
          <div>
            @if (i > 0) {
              <a tabindex="0" class="block" (agInteract)="goToPage(page)">
                {{ page.label }}
              </a>
            }
          </div>
        }
      }
    }

    <!-- YOUR ITEMS -->
    @if (!userData?.isGuest && (sharedService.kidsCat$ | async) === false) {
      <div>
        <i class="fa fa-files-o" aria-hidden="true"></i>
        <h5 class="inline">Your Items</h5>
        @if (userData.systemCategory !== SYSTEMCATEGORY.VERSO || userData.illOptions.hasVersoCILL) {
          <div>
            <a tabindex="0" (agInteract)="goToOtherLibraries()">Items From Other Libraries </a>
          </div>
        }
        @if (userData?.systemCategory === SYSTEMCATEGORY.VERSO) {
          <div>
            <a tabindex="0" (agInteract)="goToItemsOut()">Items Out </a>
          </div>
          <div>
            <a tabindex="0" (agInteract)="goToItemsHold()">Items On Hold </a>
          </div>
          <div>
            <a tabindex="0" (agInteract)="goToLostItems()">Lost Items </a>
          </div>
          <div>
            <a tabindex="0" (agInteract)="goToCheckoutHistory()">Checkout History </a>
          </div>
          <div>
            <a tabindex="0" (agInteract)="goToSearchAlerts()">Search Alerts </a>
          </div>
          <div>
            <a tabindex="0" (agInteract)="goToFines()">Fine and Lost Item Payment </a>
          </div>
        }
      </div>
    }

    <!-- YOUR SETTINGS -->
    @if (!userData?.isGuest) {
      <div>
        <i class="fa fa-key" aria-hidden="true"></i>
        <h5 class="inline">Your Settings</h5>
        <div>
          <a tabindex="0" (agInteract)="goToProfile()">Your Profile </a>
        </div>
        <div>
          <a tabindex="0" (agInteract)="goToPreferences()">Your Preferences </a>
        </div>
        <div>
          <a tabindex="0" (agInteract)="goToResources()">Your Favorite Resources </a>
        </div>
        @if (storageService.has('cid') && (storageService.getCid() | trimLower) !== 'kesu') {
          <div>
            <a tabindex="0" (agInteract)="goToWebLinks()">Your Favorite Web Links </a>
          </div>
        }
      </div>
    }

    <!-- SEARCH HISTORY -->
    @if (!userData?.isGuest) {
      <div>
        <a tabindex="0" title="Search History" class="block" (agInteract)="openSearchHistory()"
          ><i class="fa fa-hourglass-half" aria-hidden="true"></i>
          <h5 class="inline">Search History</h5>
        </a>
      </div>
    }

    <!-- YOUR LIST -->
    @if (showList) {
      <div>
        <a tabindex="0" class="block" (agInteract)="goToYourList()"
          ><i class="fa fa-list-alt" aria-hidden="true"></i>
          <h5 class="inline">Your Lists</h5>
        </a>
      </div>
    }

    <!-- LOG OUT -->
    @if (!userData?.isGuest) {
      <a tabindex="0" (agInteract)="onLogout()">
        <i class="fa fa-unlock-alt" aria-hidden="true"></i>
        <h5 class="inline">Log Out</h5>
      </a>
    }
  </div>
</div>
